export default __webpack_public_path__ + "static/media/lotus_mandala.9706e0b8.jpg";